import { COOKIE_MORTGAGE_SEARCH, COOKIE_SELECTED_PRODUCT } from '@/constants/cookies';
import { PRODUCT_MORTGAGES } from '@/constants/products';
import { CALLBACK_THRESHOLD_FTB, CALLBACK_THRESHOLD_MOVER, CALLBACK_THRESHOLD_SWITCHER, MORTGAGE_PURPOSES, MORTGAGE_STEPS } from '@/constants/mortgages';
import { getMortgageSearch } from '@/graphql/queries/banking/mortgage';
import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/mortgage';
import get from 'lodash/get';

export default async ({ $apolloQuery, app, $cookies, redirect, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const backToSearch = () => {
    $cookies.remove(COOKIE_MORTGAGE_SEARCH);
    redirect(302, app.localePath('/compare-mortgages/'), { flashClass: 'error', flashMessage: store.$i18n.t('errors.mortgageSearchNotPresent') });
  };
  if (route.params.purpose && !MORTGAGE_PURPOSES.includes(route.params.purpose)) return backToSearch();
  if (route.params.step && !MORTGAGE_STEPS.includes(route.params.step)) return backToSearch();
  if (!store.getters['user/getCustomer'].sname && ['callback-2', 'callback-3'].includes(route.params.step)) {
    return redirect(302, route.path.replace(/callback-.*/, 'callback-1'));
  }
  if (route.params.step === 'step-1') {
    const purpose = { 'first-time-buyer': 'FTB', 'moving-home': 'TRD', 'switching-mortgage': 'SM' }[route.params.purpose];
    store.commit('search/reset', { type: 'mortgage', search: { purpose } });
  } else {
    const code = $cookies.get(COOKIE_MORTGAGE_SEARCH);
    if (!code) return backToSearch();
    const params = { code };
    if (route.params.step === 'step-2') {
      params.page = 1;
      params.per = 1;
    }
    await $apolloQuery(getMortgageSearch, params).then(search => {
      if (search.purpose !== 'LL') {
        let threshold = CALLBACK_THRESHOLD_FTB;
        if (search.purpose === 'TRD') threshold = CALLBACK_THRESHOLD_MOVER;
        if (search.purpose === 'SM') threshold = CALLBACK_THRESHOLD_SWITCHER;

        if (search.amount < threshold) {
          return redirect(302, app.localePath('/compare-mortgages/'), { flashClass: 'error', flashMessage: store.$i18n.t('errors.mortgageThresholdNotMet', { threshold: store.$i18n.n(threshold, ' currencyRound') }) });
        }
      }
      store.commit('search/set', search);
      store.commit('utils/setPagination', get(search, 'results.meta.pagination'));
    }).catch(_ => backToSearch());
  }
  await $apolloQuery(getProviders, { product: PRODUCT_MORTGAGES }).then(providers => store.commit('providers/setList', providers));
  const prefix = route.path.match(/lifetime-loans/) ? 'search.lifetimes-loan' : 'search';
  const description = store.$i18n.t(`${prefix}.description`);
  const title = store.$i18n.t(`${prefix}.title`);
  store.commit('pageContent/setHead', { description, title });
  store.commit('products/set', $cookies.get(COOKIE_SELECTED_PRODUCT));
};
